export default "assets/images/icons/slider-arrow-c79836d0.svg";